import ServerManager from "./ServerManager";

export default class ArtistSuggestionsStatusService {

    static #currentTotal = 0;
    static #listeners = [];
    static #isStopped = true;

    static async start() {
        if (!this.#isStopped)
            return;

        this.#isStopped = false;

        while (!this.#isStopped) {
            await this.forceUpdate();
            await new Promise(resolve => setTimeout(resolve, 60000));
        }
    }

    static stop() {
        if (this.#isStopped)
            return;

        this.#isStopped = true;
        this.#listeners = [];
    }

    static getCurrentTotal() {
        return this.#currentTotal;
    }

    // also for manual calls
    static async forceUpdate() {
        if (this.#isStopped)
            return;

        try {
            const data = await ServerManager.getSimpleModeFilteredList("artist_suggestions", 1, "", "id", "asc");
            if (!this.#isStopped) {
                this.#currentTotal = data.total;
            }
        }
        catch (error) {
        }

        if (!this.#isStopped) {
            for (const listener of this.#listeners) {
                listener(this.#currentTotal);
            }
        }
    }

    static forceSetCurrentTotal(total) {
        if (this.#isStopped)
            return;

        this.#currentTotal = total;

        for (const listener of this.#listeners) {
            listener(this.#currentTotal);
        }
    }

    static addListener(listener) {
        this.#listeners.push(listener);
    }

    static removeListener(listener) {
        this.#listeners = this.#listeners.filter(x => x !== listener);
    }
}